var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8576 1.28613H2.14328C1.66917 1.28613 1.28613 1.66917 1.28613 2.14328V21.8576C1.28613 22.3317 1.66917 22.7147 2.14328 22.7147H21.8576C22.3317 22.7147 22.7147 22.3317 22.7147 21.8576V2.14328C22.7147 1.66917 22.3317 1.28613 21.8576 1.28613ZM20.7861 20.7861H3.2147V3.2147H20.7861V20.7861Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87721 16.3677C9.9677 16.494 10.087 16.5969 10.2252 16.6679C10.3634 16.7389 10.5166 16.776 10.6719 16.776C10.8273 16.776 10.9805 16.7389 11.1187 16.6679C11.2569 16.5969 11.3762 16.494 11.4667 16.3677L17.9414 7.39045C18.0582 7.22751 17.9414 7 17.7415 7H16.2996C15.986 7 15.6878 7.15065 15.5034 7.40889L10.6735 14.1111L8.4845 11.0736C8.30004 10.8184 8.0049 10.6647 7.68823 10.6647H6.24634C6.04651 10.6647 5.92968 10.8922 6.04651 11.0551L9.87721 16.3677V16.3677Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c40718ab379d2e5abdb8c37f9a30d266.svg";
export { ForwardRef as ReactComponent };